import SendSignInInstructionsPopup from "./SendSignInInstructionsPopup";

export default SendSignInInstructionsPopup;